import Accordion from './Accordion';
import AccordionGroup from './AccordionGroup';

export default Accordion;
export { AccordionGroup };
